import { IdentificacaoPostHog } from './posthog-identificacao';

let chaveAplicada: string | null = null;
let logoutEmitido = false;

function chaveDe(ident: IdentificacaoPostHog): string {
  return JSON.stringify(ident);
}

/**
 * Informa se esta identificação é a que já foi enviada ao SDK.
 *
 * Serve ao caminho que roda repetidamente sem ser uma transição de identidade: o
 * APP_INITIALIZER é executado a cada montagem da folha, porque cada montagem recria os
 * serviços injetáveis. Sem esta verificação, toda navegação que remonta a folha
 * reenviaria identify/register idênticos.
 *
 * A comparação usa o payload inteiro, não só o distinctId: troca de tenant ou de idioma
 * muda as propriedades registradas e precisa ser reenviada.
 */
export function identidadeJaAplicada(ident: IdentificacaoPostHog): boolean {
  return chaveDe(ident) === chaveAplicada;
}

/**
 * Marca a identificação como enviada, para que o initializer seguinte não a repita.
 *
 * Também zera o marcador de logout: um login novo invalida um marcador que nunca foi
 * consumido, para que ele não engula um logout legítimo mais tarde.
 */
export function registrarIdentidadeAplicada(ident: IdentificacaoPostHog): void {
  chaveAplicada = chaveDe(ident);
  logoutEmitido = false;
}

/**
 * Esquece a identidade aplicada no logout, para que o próximo login reidentifique.
 *
 * Não zera o marcador de logout: o reset do logout chama esta função depois de o marcador
 * ter sido gravado, e ele ainda precisa chegar ao logout do Angular.
 */
export function esquecerIdentidadeAplicada(): void {
  chaveAplicada = null;
}

/** Marca que o fluxo React já emitiu o evento de logout desta saída de sessão. */
export function registrarLogoutEmitido(): void {
  logoutEmitido = true;
}

/** Lê e zera o marcador; o primeiro logout Angular depois do React não reemite o evento. */
export function consumirLogoutEmitido(): boolean {
  const emitido = logoutEmitido;
  logoutEmitido = false;
  return emitido;
}
